const API_URL = "https://soulmegle.com:9000/api/contact";


export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/submit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    // Handle rate limit response
    if (response.status === 429) {
      const text = await response.text();
      throw new Error(text);
    }

    // Handle other responses
    const data = await response.text();
    try {
      return JSON.parse(data); // Try to parse as JSON
    } catch {
      return { message: data }; // Return text response if not JSON
    }
  } catch (error) {
    console.error("Contact form submission error:", error);
    throw error;
  }
};